module.exports = __webpack_public_path__ + "img/indexbg.9cfeff7a.png";